export default {
  setLoading (state, status) {
    state.loading = status
  },
  setFiscalYears (state, fiscalYears) {
    state.fiscalYears = fiscalYears
  }
}
